
import { BookmarkType } from 'redux/schemas/models/bookmark';
import angular from 'angular';
import { AiTranslationProgress } from 'shared/ai-translation-progress';
import { AUTOMATED_TRANSLATION_LANGUAGES } from 'automated_translation/components/language-picker';
import { QuizQuestionType } from 'redux/schemas/models/quiz';

/* @ngInject */
export default function nvLectureVideoMainBody(
  $rootScope,
  $stateParams,
  $state,
  CurrentUserManager,
  DiscussionsManager,
  BookmarkModel,
  $uibModal,
  $window,
  $translate,
  $timeout,
  _,
  $q,
  PostModel,
  AlertMessages,
  CurrentCourseManager,
  TimelinesManager,
  ReactTimelineService,
  nvUtil,
) {
  return {
    restrict: 'A',
    scope: {
      currentLectureVideoList: '=',
      discussionUpdated: '=?',
      course: '=',
      scrollToLectureComponent: '&?',
      showEdit: '=?',
      viewMode: '=?',
      context: '@',
      lectureComponent: '=',
    },
    controller: function ctrl($scope, $element, $attrs) {
'ngInject';
      const vm = this;
      const myWindow = angular.element($window);

      vm.currentLectureVideo = vm.currentLectureVideoList.currentLectureVideo;
      vm.CurrentCourseManager = CurrentCourseManager;
      let hasNotGottenPoints = !vm.currentLectureVideo.pointsReceived;
      vm.CurrentUserManager = CurrentUserManager;
      vm.DiscussionsManager = DiscussionsManager;
      vm.isTypeAudio = this.currentLectureVideoList.type === 'AudioListLectureComponent';
      vm.offsetStartTime = null;
      vm.autostart = false;
      vm.isContentManagementCollection = CurrentCourseManager.course.isContentManagementCollection;
      vm.AiTranslationProgress = AiTranslationProgress;
      vm.isLinked = vm.lectureComponent?.lecturePage?.isLinked;

      if (!vm.isTypeAudio) {
        loadVideoDetails();
      }

      function loadVideoDetails() {
        loadQuizDetails();
        loadDiscussionDetails();
        setCaptionsInfo();
      }

      function loadQuizDetails() {
        vm.currentLectureVideo.getQuiz($stateParams.catalogId)
          .then(() => {
            vm.timeCallback(vm.currentLectureVideo.startPlaybackFrom);
          });
      }

      function loadDiscussionDetails() {
        if (vm.currentLectureVideoList.discussionUpdated) {
          vm.currentLectureVideo.post = null;
        }
        if (!vm.currentLectureVideo.post
          && vm.currentLectureVideo.allowsDiscussions
          && vm.currentLectureVideo.topic) {
          /**
           * Setting the discussion title as the title of the topic forum.
           * Otherwise, it will show the video name as the title.
           */
          if (vm.currentLectureVideo.topic?.forum?.title) {
            vm.currentLectureVideo.topic.title = vm.currentLectureVideo.topic.forum.title;
          }

          vm.currentLectureVideo.post = PostModel.normalizePostData(vm.currentLectureVideo.topic, {
            owner: vm.currentLectureVideo.topic.forum,
            catalogId: $stateParams.catalogId,
            lectureVideo: vm.currentLectureVideo,
          });
          if (DiscussionsManager.currentPosts.length === 0) {
            DiscussionsManager.currentPosts.push(vm.currentLectureVideo.post);
          } else {
            const indexOfOldPost = _.findIndex(DiscussionsManager.currentPosts, { id: vm.currentLectureVideo.post.id });
            const oldPost = DiscussionsManager.currentPosts[indexOfOldPost];
            _.extend(oldPost, vm.currentLectureVideo.post);
          }
        } else if (vm.currentLectureVideo.topic && !vm.currentLectureVideo.topic.topicId) {
          vm.currentLectureVideo.topic.topicId = vm.currentLectureVideo.topic.forumId;
        }
      }

      function setCaptionsInfo() {
        // Centralized info about the manual and auto-generated captions
        const manualCaptions = vm.currentLectureVideo.video.captions;
        const captions = [];
        let defaultCaptionExist = false;

        const autoTranslatedCaption = vm.currentLectureVideo.video.autoTranslated?.caption;
        if (autoTranslatedCaption
          && autoTranslatedCaption.status === 'completed'
          && !!CurrentUserManager.user.translationPreferenceLanguage) {
          const autoTranslatedLanguageKey = autoTranslatedCaption?.language?.translationKey?.toUpperCase();
          const currentUserLanguage = AUTOMATED_TRANSLATION_LANGUAGES.find(language => language.isoCode === CurrentUserManager.user.translationPreferenceLanguage);
          // Using the includes() instead of "===" is because translation keys for Indonesian
          // is id_ID in BE but just ID in FE.
          if (autoTranslatedLanguageKey
            && (autoTranslatedLanguageKey === currentUserLanguage.translationKey
            || autoTranslatedLanguageKey.split('_')[0] === currentUserLanguage?.translationKey?.split('_')[0])
          ) {
            captions.push({
              type: 'auto_translated',
              language: autoTranslatedCaption?.language?.translationKey,
              label: autoTranslatedCaption.language.label,
              fileUrl: autoTranslatedCaption?.url,
              isDefault: true,
            });
            defaultCaptionExist = true;
          }
        }

        if (vm.currentLectureVideo.video.autoGenerateCaption) {
          const autoGeneratedCaption = vm.currentLectureVideo.video.autoGenerated?.caption;
          if (autoGeneratedCaption && !manualCaptions.find(caption => caption.fileUrl === autoGeneratedCaption.url)) {
            captions.push({
              type: 'auto_generated',
              language: autoGeneratedCaption?.language?.translationKey,
              fileUrl: autoGeneratedCaption?.url,
            });
          }
        }

        if (manualCaptions?.length > 0) {
          captions.push(...manualCaptions);
        }

        if (!!CurrentUserManager.user.translationPreferenceLanguage && !defaultCaptionExist) {
          const currentUserLanguage = AUTOMATED_TRANSLATION_LANGUAGES.find(language => language.isoCode === CurrentUserManager.user.translationPreferenceLanguage);
          const defaultCaption = captions.find(caption => {
            const languageKey = caption?.language?.toUpperCase();
            return languageKey && languageKey === currentUserLanguage.translationKey;
          });
          if (defaultCaption) {
            defaultCaption.isDefault = true;
          }
        }

        if (captions?.length > 0) {
          vm.currentLectureVideo.video.captions = captions;
        }
      }

      // Some other ways of updating discussion cause a weird jump in the UI unfortunately
      $scope.$watch('vm.discussionUpdated', (newVideoUrl, oldVideoUrl) => {
        if (newVideoUrl !== oldVideoUrl) {
          if (!vm.isTypeAudio) {
            _.extend(vm.currentLectureVideo, _.pick(vm.currentLectureVideoList.currentLectureVideo, 'allowsDiscussions', 'topic', 'post', 'topicId'));
            loadDiscussionDetails();
            vm.currentLectureVideoList.discussionUpdated = false;
          }
        }
      });

      $scope.$watch('vm.currentLectureVideoList.currentLectureVideo', (newLectureVideo, oldLectureVideo) => {
        if (newLectureVideo && vm.currentLectureVideo.id !== newLectureVideo.id) {
          setVideo(newLectureVideo, false);
        }
      });

      // only for embedded
      function setVideo(lectureVideo, autostart = true) {
        vm.currentLectureVideoList.currentLectureVideo = lectureVideo;
        vm.currentLectureVideo = lectureVideo;
        vm.offsetStartTime = null;
        vm.autostart = autostart;
        hasNotGottenPoints = !vm.currentLectureVideo.pointsReceived;
        loadVideoDetails();
      }

      vm.selectLectureVideo = function (lectureVideo) {
        showWarningModalsIfNecessary().then(() => {
          setVideo(lectureVideo);
          if (vm.scrollToLectureComponent) {
            vm.scrollToLectureComponent({ id: vm.currentLectureVideoList.id });
          }
        });
      };

      /* Video Level */
      vm.eventCallback = (event, second, totalLength) => {
        const hasFinishedVideo = event === 'ended' ? true : undefined;
        const promise = vm.currentLectureVideo.eventCallback(event, second, totalLength, hasFinishedVideo);

        if (promise) {
          promise.then(() => {
            TimelinesManager.updateComponentProgress(vm.currentLectureVideoList.lecturePage.id, 'lecture_video', vm.currentLectureVideo.id, vm.currentLectureVideo.progress);
          });
        }

        if (!CurrentUserManager.isAdmin()) {
          nvUtil.addUserToHeads(CurrentUserManager.user, vm.currentLectureVideo.usersRecentlyStartedWatching);
        }
      };

      const focusInput = (question) => {
        $timeout(() => {
          // input element of quiz question
          const inputElement = document.getElementById(`question_${question?.id}`);

          switch (question.type) {
            case QuizQuestionType.MULTIPLE_CHOICE:
            case QuizQuestionType.MULTIPLE_CHOICE_MULTIPLE_ANSWER:
            {
              // while multiple choice questions appears during video, need to focus first radio button/check box
              const firstResponseOptionElement = document.getElementById(`option_${question?.responseOptions[0]?.id}`);

              if (firstResponseOptionElement) {
                firstResponseOptionElement.focus();
              }
              break;
            }
            case QuizQuestionType.ALL_QUESTION_VIEW_SHORT_TEXT_QUESTION:
            case QuizQuestionType.NUMBER_QUESTION:

              // focusing input element when number or short answer question appears during video
              inputElement.focus();
              break;
            case QuizQuestionType.LIKERT_SCALE_QUESTION:
            {
              // while likert question appears during video, need to focus the handle
              const handle = inputElement?.getElementsByClassName('rz-pointer rz-pointer-min');

              if (handle?.length > 0) {
                (handle[0] as HTMLElement)?.focus();
              }
              break;
            }
            case QuizQuestionType.LONG_ANSWER_QUESTION:
            {
              // while Rich text question appears during video, need to focus the froala text input
              const froalaInput = inputElement.getElementsByClassName('fr-element');

              if (froalaInput?.length > 0) {
                (froalaInput[0] as HTMLElement)?.focus();
              }
              break;
            }
            case QuizQuestionType.TABLE_SHORT_ANSWER_QUESTION:
            case QuizQuestionType.TABLE_NUMBER_QUESTION:
            {
              // while a table question appears during video, need to focus first input cell of table
              const firstInputChildQuestionId = question.childrenQuestions.find(
                (childQuestion) => !childQuestion.responseOptions[0].readOnly,
              )?.id;

              const firstTableCellInput = document.getElementById(`question_${firstInputChildQuestionId}`);

              if (firstTableCellInput) {
                firstTableCellInput.focus();
              }
              break;
            }
            default:
              break;
          }
        });
      };

      vm.timeCallback = function (second) {
        $timeout(() => {
          const question = vm.currentLectureVideo.timeCallback(second);

          if (question) {
            vm.setCurrentQuestion(question);

            // when a question from video quiz pop up, need to focus the first interactive element for accessibility
            focusInput(question);
          }
        });
      };

      vm.endCallback = function () {
        $timeout(() => {
          if (!vm.currentLectureVideo || !vm.currentLectureVideo.quiz || !vm.currentLectureVideo.quiz.currentQuestion) {
            vm.currentLectureVideo.startPlaybackFrom = 0;

            vm.offsetStartTime = null;

            const nextVideo = vm.currentLectureVideoList.getNextVideo();

            if (nextVideo) {
              showWarningModalsIfNecessary().then(() => {
                setVideo(nextVideo);
              });
            } else {
              showPointsModalIfNecessary(null, true);
            }
          }
        });
      };

      vm.getOffsetTime = function () {
        if (vm.offsetStartTime != null) {
          return vm.offsetStartTime;
        }
        return vm.currentLectureVideo.startPlaybackFrom;
      };

      /* Video Quiz */
      vm.DISPLAY_STATES = {
        WORK: 'WORK',
        FEEDBACK: 'FEEDBACK',
        ANSWER_KEY: 'ANSWER_KEY',
      };

      function resetQuizView() {
        if (vm.quizForm) {
          vm.quizForm.$setPristine();
        }
      }

      vm.setCurrentQuestion = function (question) {
        vm.currentLectureVideo.quiz.reviewQuestion = null;
        vm.currentLectureVideo.quiz.setCurrentQuestion(question);
        // vm.currentLectureVideo.play(false);

        if (question.type === QuizQuestionType.LIKERT_SCALE_QUESTION) {
          $timeout(() => {
            const inputElement = document.getElementById(`question_${question?.id}`);

            if (inputElement) {
              const handle = inputElement?.getElementsByClassName('rz-pointer rz-pointer-min');
              if (handle.length > 0) {
                // setting aria-describedBy attribute to handle element of likert scale
                handle[0].setAttribute('aria-describedBy', `question_feedback_${question?.id}`);
              }
            }
          });
        }
        if (!question.displayState) {
          if (question.currentResponse) {
            vm.viewFeedback();
          } else {
            vm.retry();
          }
        }
      };

      vm.reviewVideo = function () {
        // vm.currentLectureVideo.seekTo(vm.currentLectureVideo.getReviewOffsetTime());
        vm.offsetStartTime = vm.currentLectureVideo.getReviewOffsetTime();
        vm.autostart = true;

        vm.currentLectureVideo.quiz.reviewQuestion = vm.currentLectureVideo.quiz.currentQuestion;
        vm.currentLectureVideo.quiz.resetCurrentQuestion();
      };

      vm.submit = function () {
        let modalInstance;
        const unansweredCountModalDeffered = $q.defer();
        const finalAttemptModalDeffered = $q.defer();
        let modalInstanceCtrl;
        const { currentQuestion } = vm.currentLectureVideo.quiz;
        let showFinalAttemptModal = false;

        /* Submit with blank response */
        if (currentQuestion.isUnAnswered()) {
          // eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
          modalInstanceCtrl = ['$scope', 'unansweredCount', function ($scope, unansweredCount) {
            $scope.unansweredCount = unansweredCount;
          }];


          modalInstance = openConfirmationModal('quizzes/templates/modal-questions-blank-submit.html', modalInstanceCtrl, { unansweredCount: 1 });
          modalInstance.result.then(() => {
            unansweredCountModalDeffered.resolve();
          }, () => {
            unansweredCountModalDeffered.reject();
          });
        } else {
          unansweredCountModalDeffered.resolve();
        }

        /* Submit final attempt warning */
        if (vm.currentLectureVideo.quiz.graded) {
          if (!currentQuestion.currentResponse && vm.currentLectureVideo.quiz.maximumAttempts === 1) {
            showFinalAttemptModal = true;
          } else if (currentQuestion.currentResponse
            && currentQuestion.currentResponse.numberOfAttempts + 1 === vm.currentLectureVideo.quiz.maximumAttempts) {
            showFinalAttemptModal = true;
          }
        }

        if (showFinalAttemptModal) {
          unansweredCountModalDeffered.promise.then(() => {
            modalInstance = openConfirmationModal('quizzes/templates/modal-final-attempt.html');
            modalInstance.result.then(() => {
              finalAttemptModalDeffered.resolve();
            }, () => {
              finalAttemptModalDeffered.reject();
            });
          }, () => {
            finalAttemptModalDeffered.reject();
          });
        } else {
          finalAttemptModalDeffered.resolve();
        }

        $q.all([unansweredCountModalDeffered.promise, finalAttemptModalDeffered.promise]).then(() => {
          vm.currentLectureVideo.quiz.gradeQuestion()
            .then(() => {
              vm.viewFeedback();
            }).catch((error) => {
              AlertMessages.error('', 'FORM.ERROR');
            });
        });
      };

      vm.retry = function () {
        resetQuizView();
        focusInput(vm.currentLectureVideo.quiz.currentQuestion);

        vm.currentLectureVideo.quiz.currentQuestion.resetResponse();
        vm.currentLectureVideo.quiz.currentQuestion.displayState = vm.DISPLAY_STATES.WORK;
      };

      vm.continue = function () {
        resetQuizView();

        // vm.currentLectureVideo.seekTo(vm.currentLectureVideo.quiz.currentQuestion.second);
        vm.offsetStartTime = vm.currentLectureVideo.quiz.currentQuestion.second;
        vm.autostart = true;

        vm.currentLectureVideo.quiz.resetCurrentQuestion();
      };

      vm.viewAnswer = function () {
        resetQuizView();
        vm.currentLectureVideo.quiz.currentQuestion.displayState = vm.DISPLAY_STATES.ANSWER_KEY;
      };

      vm.viewFeedback = function () {
        resetQuizView();
        vm.currentLectureVideo.quiz.currentQuestion.displayState = vm.DISPLAY_STATES.FEEDBACK;
      };

      vm.feedbackButtonClasses = function () {
        const classes = [];

        if (vm.currentLectureVideo.quiz.graded) {
          if (!vm.currentLectureVideo.quiz.currentQuestion.currentResponse.isCorrect) {
            if (vm.currentLectureVideo.quiz.currentQuestion.currentResponse.numberOfAttempts
              < vm.currentLectureVideo.quiz.maximumAttempts) {
              classes.push('double');
              classes.push('with-link');
            } else {
              classes.push('with-double-link');
            }
          }
          // else - just a single continue button
        } else {
          classes.push('double');
          if (!vm.currentLectureVideo.quiz.currentQuestion.currentResponse.isCorrect) {
            classes.push('with-link');
          }
        }

        return classes.join(' ');
      };

      vm.createBookmark = function () {
        BookmarkModel.createBookmark({
          type: vm.isTypeAudio ? BookmarkType.AUDIO : BookmarkType.VIDEO,
          catalogId: $stateParams.catalogId,
          componentId: vm.currentLectureVideo.id,
        })
          .then(bookmark => {
            vm.currentLectureVideo.bookmarkId = bookmark.id;
          });
      };

      vm.highlightBookmark = function () {
        BookmarkModel.highlightBookmark(vm.currentLectureVideo.bookmarkId);
      };

      function showPointsModal(pointModalDeferred) {
        const { skillTaggings } = vm.currentLectureVideo.videoList;
        const skillTags = _.map(skillTaggings, 'skillTagId');
        TimelinesManager.updateComponentPointsAndProgress(
          vm.currentLectureVideoList.lecturePage.id,
          'lecture_video',
          vm.currentLectureVideo.id,
          vm.currentLectureVideo.pointsReceived,
        );
        hasNotGottenPoints = false;

        if (vm.currentLectureVideo.pointsReceived > 0 || skillTags.length > 0) {
          $uibModal.open({
            templateUrl: 'shared/templates/points-modal.html',
            windowClass: 'points-modal',
            controller: 'PointsModalCtrl as vm',
            resolve: {
              pointsReceived: vm.currentLectureVideo.pointsReceived,
              leaderboardPoints: vm.currentLectureVideo.leaderboardPoints,
              leaderboardRank: vm.currentLectureVideo.leaderboardRank,
              priorLeaderboardRank: vm.currentLectureVideo.priorLeaderboardRank,
              extras: { skillTags },
            },
          }).result.then((result) => {
            if (pointModalDeferred) {
              pointModalDeferred.resolve();
            }
          }, (result) => {
            if (pointModalDeferred) {
              pointModalDeferred.resolve();
            }
          });
        }
      }
      function showPointsModalIfNecessary(pointModalDeferred?, showSkillsModal?) {
        if (vm.currentLectureVideo.lastEventCallbackPromise) {
          if (vm.currentLectureVideo.progress === 'completed') {
            TimelinesManager.updateComponentProgress(vm.currentLectureVideoList.lecturePage.id, 'lecture_video', vm.currentLectureVideo.id, 'completed');
          } else {
            vm.currentLectureVideo.lastEventCallbackPromise.then((lectureVideo) => {
              if (vm.currentLectureVideo.progress === 'completed') {
                TimelinesManager.updateComponentProgress(vm.currentLectureVideoList.lecturePage.id, 'lecture_video', vm.currentLectureVideo.id, 'completed');
              }
            });
          }
        }

        const skillsWithNoPoints = vm.currentLectureVideo.pointsConfiguration?.points === 0 && !vm.currentLectureVideo.hasFinishedVideo;
        const skillsEnabled = (
          showSkillsModal
          && vm.currentLectureVideo.videoList.skillTaggings?.length > 0
          && vm.currentLectureVideo.progress !== 'completed'
        ) || skillsWithNoPoints;
        const pointsEnabled = CurrentCourseManager.course?.gamificationEnabled && vm.currentLectureVideo.pointsConfiguration;
        const shouldShowCelebrationModal = (pointsEnabled || skillsEnabled) && (hasNotGottenPoints || !pointsEnabled);

        if (shouldShowCelebrationModal) {
          if (vm.currentLectureVideo.newPointsReceived) {
            vm.currentLectureVideo.pointsReceived = vm.currentLectureVideo.newPointsReceived;
            vm.currentLectureVideo.leaderboardPoints = vm.currentLectureVideo.newLeaderboardPoints;
            vm.currentLectureVideo.leaderboardRank = vm.currentLectureVideo.newLeaderboardRank;
            vm.currentLectureVideo.priorLeaderboardRank = vm.currentLectureVideo.newPriorLeaderboardRank;
            showPointsModal(pointModalDeferred);
          } else if (
            !vm.currentLectureVideo.length
            || vm.currentLectureVideo.startPlaybackFrom / vm.currentLectureVideo.length >= vm.currentLectureVideo.pointsConfiguration.threshold
          ) {
            if (vm.currentLectureVideo.lastEventCallbackPromise) {
              vm.currentLectureVideo.lastEventCallbackPromise.then((lectureVideo) => {
                if (vm.currentLectureVideo.newPointsReceived) {
                  vm.currentLectureVideo.pointsReceived = vm.currentLectureVideo.newPointsReceived;
                  vm.currentLectureVideo.leaderboardPoints = vm.currentLectureVideo.newLeaderboardPoints;
                  vm.currentLectureVideo.leaderboardRank = vm.currentLectureVideo.newLeaderboardRank;
                  vm.currentLectureVideo.priorLeaderboardRank = vm.currentLectureVideo.newPriorLeaderboardRank;
                  showPointsModal(pointModalDeferred);
                } else if (pointModalDeferred) {
                  pointModalDeferred.resolve();
                } else if (skillsEnabled) {
                  showPointsModal(pointModalDeferred);
                }
              });
            } else {
              pointModalDeferred.resolve();
            }
          }
          vm.currentLectureVideo.hasFinishedVideo = true;
        } else if (pointModalDeferred) {
          pointModalDeferred.resolve();
        }
      }

      function showWarningModalsIfNecessary() {
        let modalInstance;
        const pointModalDeferred = $q.defer();
        const dirtyQuizDeferred = $q.defer();

        vm.currentLectureVideo.play(false);

        showPointsModalIfNecessary(pointModalDeferred);

        pointModalDeferred.promise.then(() => {
          if (vm.quizForm?.$dirty) {
            modalInstance = openConfirmationModal('shared/templates/modal-navigate-away.html');
            modalInstance.result.then(() => {
              dirtyQuizDeferred.resolve();
            }, () => {
              dirtyQuizDeferred.reject();
            });
          } else {
            dirtyQuizDeferred.resolve();
          }
        });

        return $q.all([pointModalDeferred.promise, dirtyQuizDeferred.promise]);
      }

      vm.aiTranslatingCaptionsState = function () {
        let status;
        switch (vm.currentLectureVideo.video.autoTranslated?.caption?.status) {
          case 'completed':
            status = AiTranslationProgress.TRANSLATED;
            break;
          case 'in_progress':
            status = AiTranslationProgress.TRANSLATING;
            break;
          default:
            status = AiTranslationProgress.UNAVAILABLE;
        }
        if (vm.currentLectureVideo.video.autoTranslated?.caption?.errorCode) {
          status = AiTranslationProgress.CANNOT_TRANSLATE;
        }
        if (!CurrentUserManager.user.translationPreferenceLanguage) {
          status = AiTranslationProgress.UNAVAILABLE;
        }
        if (status !== AiTranslationProgress.CANNOT_TRANSLATE && CurrentUserManager.user.translationPreferenceLanguage) {
          const autoTranslatedLanguageKey = vm.currentLectureVideo.video.autoTranslated?.caption?.language?.translationKey?.toUpperCase();
          const currentUserLanguage = AUTOMATED_TRANSLATION_LANGUAGES.find(language => language.isoCode === CurrentUserManager.user.translationPreferenceLanguage);
          // Using the includes() instead of "===" is because translation keys for Indonesian
          // is id_ID in BE but just ID in FE.
          if (!autoTranslatedLanguageKey
            || (autoTranslatedLanguageKey !== currentUserLanguage.translationKey
            && autoTranslatedLanguageKey.split('_')[0] !== currentUserLanguage.translationKey.split('_')[0])
          ) {
            status = AiTranslationProgress.UNAVAILABLE;
          }
        }
        return status;
      };

      /* Warning when you navigate away with unsaved changes */
      $rootScope.$on('$stateChangeStartWithPromiseReplacement', (event, toState, toParams, fromState, fromParams, setResolvePromise) => {
        if (vm.viewMode) {
          setResolvePromise(showWarningModalsIfNecessary());
        }
      });

      /* Warning when you navigate away with unsaved changes */
      $rootScope.$on('video-auto-translated-caption-updated', (event, captionData) => {
        if (vm.currentLectureVideo.video.id === captionData.videoId) {
          vm.currentLectureVideo.video.autoTranslated = {
            caption: captionData,
          };
          setVideo(vm.currentLectureVideo, false);
        } else {
          const videoInList = vm.currentLectureVideoList.lectureVideos.find(lectureVideo => lectureVideo.video.id === captionData.videoId);
          if (videoInList) {
            videoInList.video.autoTranslated = {
              caption: captionData,
            };
          }
        }
      });

      /** Whether the title for the current video quiz is using the default values of 'Question' or 'Quiz' */
      vm.quizTitleIsDefault = function () {
        return vm.currentLectureVideo.quiz.title === 'Question' || vm.currentLectureVideo.quiz.title === 'Quiz';
      };

      myWindow.on('beforeunload', (e) => {
        let msg;

        if (vm.quizForm?.$dirty) {
          msg = 'FORM.UNSAVED_CHANGES.NAVIGATE_AWAY';

          ((e || window.event) as any).returnValue = msg; // Gecko + IE
          return msg; // Webkit, Safari, Chrome etc.
        }

        // Prevent a confirm dialog form appearing
        return undefined;
      });

      $scope.$on('$destroy', () => {
        vm.deregisterStateChangeStart?.();

        DiscussionsManager.unsubscribeFromPusherEvents();
        DiscussionsManager.resetSearchParams();
      });

      $scope.$on('slideEnded', () => {
        vm.quizForm.$setDirty();
      });

      /** Private Helpers * */
      function openConfirmationModal(templateUrl, modalInstanceCtrl?, data?) {
        return $uibModal.open({
          backdropClass: 'modal-overlay-backdrop',
          controller: modalInstanceCtrl,
          controlleras: 'vm',
          templateUrl,
          windowClass: 'modal-overlay',
          resolve: data,
        });
      }
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'lecture_videos/templates/nv-lecture-video-main-body.html',
  };
}
